export { default } from './TrendTopic';
